import { FC } from 'react';
import { FaFileLines } from 'react-icons/fa6';
import { MdOutlineDatasetLinked, MdRequestPage } from 'react-icons/md';

import { getVideoThumbLineUrl } from '@/core/utils/helpers';
import { appSettings } from '@/settings/app-settings';

const PreviewContent: FC<{
  contentType: string;
  content: { url?: string; text?: string };
}> = ({ contentType, content }) => {
  return (
    <>
      {contentType == 'image' && content.url && (
        <img
          className="w-full h-full flex object-cover"
          src={appSettings.api.S3_MEDIA_COMPRESSED + content.url}
          alt=""
        ></img>
      )}
      {contentType == 'video' && content.url && (
        <img
          className="w-full h-full flex object-cover"
          src={appSettings.api.S3_MEDIA_COMPRESSED + getVideoThumbLineUrl(content.url)}
          alt=""
        ></img>
      )}
      {contentType == 'text' && (
        <div className="w-full h-full flex p-4">
          <FaFileLines className="w-full h-full" />
        </div>
      )}
      {contentType == 'link' && (
        <div className="w-full h-full flex p-4">
          <MdOutlineDatasetLinked className="w-full h-full" />
        </div>
      )}
      {contentType == 'asset' && (
        <div className="w-full h-full flex p-4">
          <MdRequestPage className="w-full h-full" />
        </div>
      )}
    </>
  );
};

export default PreviewContent;
